import React from "react";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";

const MedicalConsent = {
  PhoneNumberNote: (
    <p>
      <strong>Please note: </strong>
      We'll use this phone number if we need to contact you about this claim. It
      won't update your main contact details.
    </p>
  ),
  Title1: "Preparation",
  Title2: {
    MOL: "Member details",
    HOL: "Patient details"
  },
  Title3: "Accident or emergency",
  Title4: "Declaration",
  Title5: "Medical reports",
  ProvideDeclarationPageTitle: "Declaration and consent",
  MemberDetailsPageTitle: {
    HOL: "Patient details",
    MOL: "Member details"
  },
  ProvideDeclarationPageBody: {
    Saga: (
      <React.Fragment>
        <p>
          <strong>
            I wish to claim benefit and I declare that all the information I
            have given on this form is correct to the best of my knowledge.
          </strong>
        </p>
        <p>
          <strong>I consent to {RebrandHelper.getCompanyName()}:</strong>
        </p>
        <ol type="a">
          <li>
            Requesting medical and health information from the patient's
            healthcare practitioner and/or hospital
          </li>
          <li>
            The healthcare practitioner and/or hospital providing that health
            information in reports, or by copies of my health records and
            medical information, to {RebrandHelper.getCompanyName()}
          </li>
          <li>
            The healthcare practitioner and/or hospital involved in the
            patient's care reviewing medical information and discharge
            arrangements with {RebrandHelper.getCompanyName()} for the following
            reasons: (Please tick yes or no for each of the following)
          </li>
        </ol>
      </React.Fragment>
    ),
    LargeCorporate: (
      <React.Fragment>
        <p>
          <strong>
            I wish to claim benefit and I declare that all the information I
            have given on this form is correct to the best of my knowledge.
          </strong>
        </p>
        <p>
          <strong>I consent to {RebrandHelper.getCompanyName()}:</strong>
        </p>
        <ol type="a">
          <li>
            Requesting medical and health information from the patient's
            healthcare practitioner and/or hospital
          </li>
          <li>
            The healthcare practitioner and/or hospital providing that health
            information in reports, or by copies of my health records and
            medical information, to {RebrandHelper.getCompanyName()}
          </li>
          <li>
            The healthcare practitioner and/or hospital involved in the
            patient's care reviewing medical information and discharge
            arrangements with {RebrandHelper.getCompanyName()} for the following
            reasons: (Please tick yes or no for each of the following)
          </li>
        </ol>
      </React.Fragment>
    ),
    MOL: (
      <React.Fragment>
        <p>
          <strong>
            I declare that all the information I have given on this form is
            correct to the best of my knowledge.
          </strong>
        </p>
        <p>
          <strong>I consent to AXA PPP healthcare Limited:</strong>
        </p>
        <ol type="a">
          <li>
            Requesting medical and health information from the patient's
            healthcare practitioner and/or hospital
          </li>
          <li>
            The healthcare practitioner and/or hospital providing that health
            information in reports, or by copies of my health records and
            medical information, to AXA PPP healthcare Limited
          </li>
          <li>
            The healthcare practitioner and/or hospital involved in the
            patient's care reviewing medical information and discharge
            arrangements with AXA PPP healthcare Limited for the following
            reasons: (Please tick yes or no for each of the following)
          </li>
        </ol>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          I wish to claim benefit and I declare that all the information I have
          given on this form is correct to the best of my knowledge.
        </p>
        <p>I consent to Health-on-Line and {RebrandHelper.getCompanyName()}:</p>
        <ol type="a">
          <li>
            Requesting medical and health information from the patient's
            healthcare practitioner and/or hospital
          </li>
          <li>
            The healthcare practitioner and/or hospital providing that health
            information in reports, or by copies of my health records and
            medical information, to Health-on-Line and{" "}
            {RebrandHelper.getCompanyName()}
          </li>
          <li>
            The healthcare practitioner and/or hospital involved in the
            patient’s care reviewing medical information and discharge
            arrangements with Health-on-Line and{" "}
            {RebrandHelper.getCompanyName()} for the following reasons: (Please
            tick yes or no for each of the following)
          </li>
        </ol>
      </React.Fragment>
    )
  },
  ProvideDeclarationYourNameLabel: "Your name",
  ProvideDeclarationPatientOver16Message:
    "You are unable to give medical consent for this patient as they are over the age of 16, the patient will need to give us consent directly.",
  ProvideDeclarationPatientNameLabel: "Patient's name",
  ProvideDeclarationYourRelationshipLabel: "Your relationship to the patient",
  ProvideDeclarationAssessAndSubsequentLabel:
    "- to assess and subsequently review my claim and apply policy terms/exclusions",
  TermsAndConditionsTitle: "About your information and medical reports",
  TermsAndConditionsText: (
    <div className="long-text-wrapper">
      <h2>Important information</h2>
      <h3>Access to Medical Reports Act 1988</h3>

      <p>
        It’s important that you understand your rights under the Access to
        Medical Reports Act 1988 before you agree to us requesting a report from
        the GP or hospital treating you.
      </p>
      <p>
        A medical report is a report from your GP giving us details of your
        current condition, the history of your condition, and any proposed
        treatment.
      </p>

      <h3>Other medical reports</h3>
      <p>If we ask for a medical report:</p>
      <ul>
        <li>
          You don’t have to give your consent. If you don’t give consent, we may
          not be able to process your claim.
        </li>
        <li>We will write to you to tell you the date we requested it.</li>
        <li>
          You can see the report before it is sent to us. If you want to do
          this, you must contact the medical practitioner within 21 days of the
          date of our request. Please select Yes in section 4. <br />
          If you don’t select Yes but then change your mind, you can contact
          your medical practitioner and ask to see the report. You have 21 days
          from the date of your initial request to arrange to see it.
        </li>
        <li>
          If you disagree with the information in the report, you can ask the
          medical practitioner to change it. If the medical practitioner does
          not agree with you, they will ask you to write a statement to go with
          the report that is sent to us.
        </li>
        <li>
          You can ask the medical practitioner to see the report at any time
          within six months of the medical practitioner sending it to us.
        </li>
        <li>
          Your medical practitioner may charge you for a copy of the report.
          This charge is not covered by your plan.
        </li>
        <li>
          Your medical practitioner does not have to show you parts of the
          report if they think it could cause harm to your physical or mental
          health, or if it shows future plans for your care that the medical
          practitioner doesn’t want you to see.
        </li>
        <li>
          If the report includes information about someone else, the medical
          practitioner will not show you that part of the report.
        </li>
      </ul>
      <p>
        These rights do not relate to reports from practitioners who are not
        treating you and who we might ask for an opinion.
      </p>

      <h3>Data Protection</h3>
      <ul>
        <li>
          We’ll handle your personal data in accordance with the Data Protection
          Legislation
        </li>
        <li>You are entitled to see information we hold about you.</li>
        <li>
          You can write to us to ask for a copy of any personal information
          about you in any independent reports we request.
        </li>
        <li>
          If you would like a copy of a medical report that your medical
          practitioner has sent to us, it will be quickest if you contact them
          direct because we will have to get their permission to release it to
          you.
        </li>
        <li>We process claims outside the European Economic Area.</li>
        <li>
          If any medical records we receive show that a medical condition should
          have been declared on your plan application, we may change the terms
          of your plan.
        </li>
        <li>
          For our full Privacy Policy please see {RebrandHelper.getAxaDomain()}
          /privacynotice.
        </li>
      </ul>

      <h3>Preventing and detecting crime, and auditing records</h3>
      <p>
        We may audit the medical records of medical practitioners and hospitals
        to:
      </p>
      <ul>
        <li>prevent and detect crime, particularly fraud;</li>
        <li>review the performance of specialists;</li>
        <li>ensure that we are being correctly billed for their services.</li>
      </ul>
      <p>
        Audits may be part of a programme or in response to a specific event.
      </p>

      <h3>Sharing information</h3>
      <p>
        We may need to share information with third parties, including medical
        experts, other insurers, the NHS Counter Fraud Security Management
        Service and the General Dental Council.
      </p>
      <p>
        In certain circumstances, we are required by law to disclose information
        to law enforcement agencies about suspicions of fraudulent claims and
        other crimes. This may involve adding non-medical information to
        databases that can be viewed by other insurers and law enforcement
        agencies.
      </p>
      <p>
        We are required to tell the General Medical Council, or other relevant
        regulatory body, about any issue where we have reason to doubt a medical
        provider’s fitness to practise.
      </p>
    </div>
  ),
  TermsAndConditionsAcceptTsandCsLabel:
    "I accept the terms outlined in the Important Information section above",
  ProvideDeclarationAuditHealthcareLabel: {
    MOL:
      "- to audit healthcare practitioner and hospital records to review their performance and ensure that AXA is being billed correctly",
    HOL: `- to audit healthcare practitioner and hospital records to review their performance and ensure that Health-on-Line and ${RebrandHelper.getCompanyName()} is being billed correctly`,
    LargeCorporate: `- to audit healthcare practitioner and hospital records to review their performance and ensure that AXA is being billed correctly`
  },
  ProvideDeclarationIAmThePatientLabel: "I am the patient",
  ProvideDeclarationPatientUnder16Label: "The patient is under 16 years of age",
  ProvideDeclarationPatientParentLabel: "I am the patient's parent / guardian",
  ProvideDeclarationSeeReportLabel: {
    MOL: `I wish to see any report from the medical practitioner and/or hospital before it's sent to AXA PPP healthcare Limited`,
    HOL: `I wish to see any report from the medical practitioner and/or hospital before it’s sent to Health-on-Line and ${RebrandHelper.getCompanyName()}.`,
    LargeCorporate: `I wish to see any report from the medical practitioner and/or hospital before it's sent to ${RebrandHelper.getCompanyName()}`,
    Saga: `I wish to see any report from the medical practitioner and/or hospital before it's sent to ${RebrandHelper.getCompanyName()}`
  },
  ProvideDeclarationFooterText:
    "We may keep full copies of information we get from your medical records for three months after we've reviewed your claim. We'll then delete them from our system. This means that if you later claim for a different medical condition, we may need to request them again.",
  ProvideEmergencyConsentPageTitle: "Claiming for an accident or an emergency",
  ProvideEmergencyConsentPageBody:
    "Sometimes we can recover the money we pay for treatment from a third party if it was as a result of someone else's fault, possible medical negligence or it's covered by another insurer. Answering these questions will help us decide if this is an option for us. The answers will not affect the outcome of your claim with us.",
  ProvideEmergencyConsentGroupLabelOne:
    "Are you having treatment as a result of an accident or incident that might have been somebody else’s fault or responsibility?",
  ProvideEmergencyConsentGroupLabelTwo:
    " Is the treatment needed as a result of possible medical negligence, for example:",
  ProvideEmergencyConsentGroupTwoDetails: (
    <ul>
      <li>a faulty medical device</li>
      <li>complication in surgery delayed diagnosis</li>
      <li>metal on metal hip replacement?</li>
    </ul>
  ),
  ProvideEmergencyConsentGroupLabelThree:
    "Do you have any other insurance policies (for example a travel plan or a company scheme) that could be responsible for a share of these costs?",
  ProvideEmergencyConsentTextInputOne: "Other insurance company's name",
  ProvideEmergencyConsentTextInputTwo: "Other insurance company's address",
  ProvideEmergencyConsentTextInputThree: "Other policy number",
  ValidationErrors: {
    AllFieldsRequired: "All fields are required",
    ClaimNumberRequiredFields: "Please enter your claim number.",
    ClaimNumberInvalidFormat: {
      MOL:
        "Please enter your claim number in a valid format. It consists of 6 letters and 6 or 7 numbers - e.g. AXACLM123456 or AXACLM1234567",
      HOL:
        "Please enter your claim number in a valid format. It consists of 6 letters and 6 or 7 numbers - e.g. HOLCLM123456 or HOLCLM1234567",
      Format2:
        "Please enter your claim number in a valid format. It consists of 3 letters and 4 numbers - e.g. ABC1234"
    },
    PhoneNumberInvalidFormat: "Please enter your valid phone number.",
    TermsAndConditionsMustBeAccepted:
      "You must accept the terms outlined in the Important Information section"
  },
  MedicalConsentConfirmation: {
    PageTitle: "Medical Consent",
    Header: "Thanks, we've received your details",
    Body: (
      <React.Fragment>
        <p>We've received your medical consent and will be in touch shortly.</p>
        <p>
          For your records, you can download a copy of the completed form using
          the link below:
        </p>
      </React.Fragment>
    ),
    BodyNote1:
      "You can only download the form once. When you click away from this screen, it will no longer be available.",
    BodyNote2: "The medical consent you've provided only applies to claim ",
    BackButtonText: "Back to claims"
  },
  MedicalConsentClaimInput: {
    PageTitle: "Medical consent",
    Tooltip: {
      MOL: (
        <p>
          Your claim number is a reference number associated with the specific
          condition you're having treatment for. It consists of six letters and
          six or Seven numbers. e.g. AXACLM123456 or AXACLM1234567.
        </p>
      ),
      HOL: (
        <p>
          Your claim number is a reference number associated with the specific
          condition you're having treatment for. It consists of six letters and
          six or seven numbers. e.g. HOLCLM123456 or HOLCLM1234567.
        </p>
      ),
      Format2: (
        <p>
          Your claim number is a reference number associated with the specific
          condition you're having treatment for. It consists of three letters
          and four numbers. e.g. ABC1234.
        </p>
      )
    },
    Label: {
      MOL: "Please enter your claim number",
      HOL: "Your claim number"
    },
    Body: {
      MOL: (
        <React.Fragment>
          <p>
            Please complete this form to help us assess your claim. It should be
            completed by the patient unless they are under the age of 16.
          </p>
          <p>It allows us to:</p>
          <ul>
            <li>
              Use your confidential data such as medical and health records
            </li>
            <li>
              Request a medical report or discuss your treatment with your
              medical practitioner or hospital on your behalf
            </li>
            <li>
              Check medical information, including medical reports, to make sure
              the information we have is correct
            </li>
          </ul>
          <p>Your consent will only apply to this claim.</p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            Please complete this form to help us assess your claim. It should be
            completed by the patient unless they are under the age of 16.
          </p>
          <p>It allows Health-on-Line and AXA PPP healthcare to: </p>
          <ul>
            <li>
              Request a medical report from your medical practitioner about your
              application or exclusions; and
            </li>
            <li>
              Carry out checks or audits to ensure the information that has been
              sent to us is correct.
            </li>
          </ul>
          <p>Your consent will only apply to this claim.</p>
        </React.Fragment>
      )
    }
  },
  ProvideMedicalConsentInput: {
    Body: "Please complete the details here to provide medical consent.",
    LeadMemberFullNameLabel: {
      MOL: "Lead member's full name",
      HOL: "Patient's full name",
      Saga: "Policyholder's full name"
    },
    LeadMemberAddressLabel: {
      MOL: "Lead member's address",
      HOL: "Patient's address",
      Saga: "Policyholder's address"
    },
    MembershipnumberLabel: "Membership number",
    PhoneNumberLabel: "Phone number",
    EmailAddressLabel: "Email address"
  }
};
export default MedicalConsent;
